/**
 *    @author:
 *    @since:
 *
 */

import { Component, ElementRef, OnInit } from '@angular/core';
import { Router } from '@angular/router'; 
import { TimerService } from 'src/refresh/service/timer-service';
import { FormBaseComponent } from '../_common/component/form-base.component';
import { Eligibility, InputData } from '../_common/data/input-data';
import { Path, Progress } from  "../_common/constant/page-const";
import { Setup4Validation } from './setup_4.validator';
import { ItemList } from '../_common/constant/item-list';
import { Util } from 'src/refresh/service/Util';
import { ProgressService } from 'src/refresh/service/progress-service';
import { ViewportScroller } from '@angular/common';

@Component({ 
      selector: 'setup_4',
      templateUrl: './setup_4.component.html',
      styleUrls: ['./setup_4.component.less']
})
export class Setup4Component extends FormBaseComponent implements OnInit {

      public error_invalidDeliveredByOther : string;
      public error_invalidBirthType : string;
      orgContactPath = Path.ORGContactInformation;
      eligibility : Eligibility;

      constructor( protected router: Router ,
            public timerService: TimerService,
            protected progress:ProgressService,
            public elRef: ElementRef,
            public data: InputData,  
            public items: ItemList,
            public viewportScroller: ViewportScroller ) {

            super(router, timerService);  
            super.setNextPage(Path.Setup5,Path.Setup3);
            super.setValidator(new Setup4Validation(this,Progress.Eligibility));

            this.eligibility = data.eligibility;

            InputData.currentPageIdx = 6;
            if ( InputData.moveNext == 0 || InputData.moveNext == InputData.currentPageIdx ) this.timerService.isForwarding = false;
      }

      public ngOnInit() {
      	 super.forwardNext(this.data.eligibility.listedParentCount);
      }

      hideMultiBirthTypeInfo(){
            return (Util.isEmpty(this.eligibility.birthType) || this.eligibility.birthType == '1');
      }

      public onCancelApplication() {
            super.cancelApplication(this.data);
      }


}